// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader[data-v-50060790]{animation:load8-50060790 1.1s linear infinite;border-style:solid;font-size:10px;margin:0;position:relative;text-indent:-9999em;transform:translateZ(0)}.loader[data-v-50060790],.loader[data-v-50060790]:after{border-radius:50%}@keyframes load8-50060790{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
